import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";

import { Row, Spin } from "antd";
import moment from "moment";

import {
  setRecordDates,
  setSearchText,
} from "../../../../redux/store/common/commonDuck";

const CancelDashboard = ({ orderDeliveryStatus }) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const isLoading = useSelector((state) => state.common.loading);
  const user = useSelector((state) => state.auth.user);
  const setIsSearchText = (value) => dispatch(setSearchText(value));
  const setDates = (value) => dispatch(setRecordDates(value));

  const handelItemClick = (searchStatus, list) => {
    setIsSearchText(searchStatus);
    if (list && list?.length > 0) {
      setDates({
        startDate: moment(list[list?.length - 1].cancel_request_date).startOf(
          "day",
        ),
        endDate: moment(list[0].cancel_request_date).endOf("day"),
      });
    } else {
      setDates({
        startDate: moment().subtract(7, "days").startOf("day"),
        endDate: moment().endOf("day"),
      });
    }
    history.push(`/salesManage/return`);
  };

  return (
    <Row className="order-component-box main-component-box">
      {isLoading && <Spin />}
      <div className={`order-component-title-div main-component-title-div`}>
        <h2 className="order-component-title">
          {/*반품/교환*/}
          취소/반품
          <span
            className={`gray-font`}
            style={{
              marginLeft: "8px",
            }}
          >
            {/*최근 30일 기준*/}
          </span>
        </h2>
      </div>
      <div
        className={`order-component-info`}
        style={{
          gap: "1rem",
        }}
      >
        <Row
          className={`order-component-each main-component-each dash-cursor`}
          align={"middle"}
          onClick={() => {
            history.push(`/salesManage/cancel`);
            // if (user && user.role && user.role === "super_admin") {
            // 	history.push(`/salesManage/cancel`);
            // } else {
            // 	history.push(`/salesManage/return`);
            // }
          }}
        >
          <span>취소요청</span>
          <p>
            <b>{orderDeliveryStatus.cancelRequest ?? 0}</b>
          </p>
        </Row>
        <Row
          className={`order-component-each main-component-each dash-cursor`}
          align={"middle"}
          onClick={() =>
            // handelItemClick("return_request", orderDeliveryStatus.returnRequest)
            handelItemClick("return_request")
          }
        >
          <span>반품요청</span>
          <p>
            <b>{orderDeliveryStatus.returnRequest ?? 0}</b>
          </p>
        </Row>
        <Row
          className={`order-component-each main-component-each dash-cursor`}
          align={"middle"}
          onClick={() => handelItemClick("return_receive")}
        >
          <span>반품승인</span>
          <p>
            <b>{orderDeliveryStatus.returnReceiveCnt ?? 0}</b>
          </p>
        </Row>
        <Row
          className={`order-component-each main-component-each dash-cursor`}
          align={"middle"}
          onClick={() =>
            handelItemClick(
              "return_delivery_complete",
              // orderDeliveryStatus.returnDeliveryComplete
            )
          }
        >
          <span>반품배송완료</span>
          <p>
            <b>{orderDeliveryStatus.returnDeliveryComplete ?? 0}</b>
          </p>
        </Row>
        {/* <Row
          className={`order-component-each main-component-each dash-cursor`}
          align={"middle"}
          onClick={() =>
            handelItemClick(
              "return_collection_fail",
              // orderDeliveryStatus.returnCollectionFail
            )
          }
        >
          <span>수거요청실패</span>
          <p>
            <b>{orderDeliveryStatus.returnCollectionFail ?? 0}</b>
          </p>
        </Row> */}
        <Row
          className={`order-component-each main-component-each dash-cursor`}
          align={"middle"}
          onClick={() =>
            // handelItemClick("return_delay", orderDeliveryStatus.returnDelay)
            handelItemClick("return_delay")
          }
        >
          <span>반품지연</span>
          <p>
            <b>{orderDeliveryStatus.returnDelay ?? 0}</b>
          </p>
        </Row>
        <Row
          className={`order-component-each main-component-each dash-cursor`}
          align={"middle"}
          onClick={() =>
            handelItemClick(
              "return_refund_delay",
              // orderDeliveryStatus.returnRefundDelay
            )
          }
        >
          <span>환불지연</span>
          <p>
            <b>{orderDeliveryStatus.returnRefundDelay ?? 0}</b>
          </p>
        </Row>
        {/*<Row*/}
        {/*    className={`order-component-each main-component-each dash-cursor`}*/}
        {/*    align={"middle"}*/}
        {/*    onClick={() => {*/}
        {/*        if (user && user.role && user.role === "super_admin") {*/}
        {/*            history.push(`/salesManage/exchange`)*/}
        {/*        } else {*/}
        {/*            history.push(`/salesManage/return`)*/}
        {/*        }*/}
        {/*    }}*/}
        {/*>*/}
        {/*    <span>교환요청</span>*/}
        {/*    <p>*/}
        {/*        <b>{orderDeliveryStatus.exchangeRequest}</b>*/}
        {/*    </p>*/}
        {/*</Row>*/}
        {/*<Row*/}
        {/*    className={`order-component-each main-component-each dash-cursor`}*/}
        {/*    align={"middle"}*/}
        {/*    onClick={() => {*/}
        {/*        if (user && user.role && user.role === "super_admin") {*/}
        {/*            history.push(`/salesManage/exchange`)*/}
        {/*        } else {*/}
        {/*            history.push(`/salesManage/return`)*/}
        {/*        }*/}
        {/*    }}*/}
        {/*>*/}
        {/*    <span>교환수거완료</span>*/}
        {/*    <p>*/}
        {/*        <b>0</b>*/}
        {/*    </p>*/}
        {/*</Row>*/}
      </div>
    </Row>
  );
};
export default CancelDashboard;
